export default __webpack_public_path__ + "static/banner_mobile-c16d7a58aeec1927f54337faf2dc54f5.webp";